angular.module('ib-monetate-module', []);
